import { Text } from '../index';
import { useDatatableContext } from './context';

const PaginationMeta = () => {
  const { internals, translations } = useDatatableContext();

  return (
    <Text heading='xs'>
      {translations?.pagination?.page
        ? translations?.pagination?.page({ page: internals.state.page })
        : `Page ${internals.state.page}`}
    </Text>
  );
};

export default PaginationMeta;
